import styled from "styled-components"

const SuccessMessageP = styled.p`
    color: green;
    font-size: 0.8rem;
    margin: 0;
    font-weight: 600;
    text-align: center;
    background-color: #f0f0f0;
    border-radius: 5px;
    padding: 10px;
    border: 1px solid green;
`

export const SuccessMessage = (props: any) => {
    return (
        <SuccessMessageP>{props.children}</SuccessMessageP>
    )
}